exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.order-depot[data-v-6f909d4e]{margin:0 10px 20px 10px\n}\n.order-depot .col-2[data-v-6f909d4e]:first-child{padding-left:0\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/orders/Depot.vue"],"names":[],"mappings":";AACA,8BAA8B,uBAAuB;CACpD;AACD,iDAAiD,cAAc;CAC9D","file":"Depot.vue","sourcesContent":["\n.order-depot[data-v-6f909d4e]{margin:0 10px 20px 10px\n}\n.order-depot .col-2[data-v-6f909d4e]:first-child{padding-left:0\n}"],"sourceRoot":""}]);

// exports
